export const ExcelHeader = [
  {
    header: "Ref No",
    key: "refNo",
  },
  {
    header: "Customer Po",
    key: "customerPo",
  },
  {
    header: "Customer",
    key: "customerCode",
  },
  {
    header: "Requirement Category",
    key: "requirementCategoryText",
  },
  {
    header: "Part Number",
    key: "pn",
  },
  {
    header: "Pool Scope",
    key: "isPool",
  },
  {
    header: "Destination",
    key: "airportCode",
  },
  {
    header: "AC",
    key: "acRegistration",
  },
  {
    header: "Requested Date",
    key: "requestedDate",
  },
  {
    header: "Requested Delivery Date",
    key: "requestedDeliveryDate",
  },
  {
    header: "Serviceable",
    key: "serviceableStatus",
  },
  {
    header: "Core Unit",
    key: "unserviceableStatus",
  },
  {
    header: "Status",
    key: "status",
  },
  {
    header: "Svc Pn",
    key: "svcPn",
  },
  {
    header: "Svc Sn",
    key: "svcSn",
  },
];
